// EditProfileModal.tsx
import React, { useEffect, useState } from "react";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/Dropdown";
import { Btn } from "../../../AbstractElements";
// import { useGetOrgUnitsData } from "../hooks/useEmployee";
import RouteDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useGetOrgUnitsData,
  useGradeMastersData,
} from "../../Configuration/Grade Master/hooks/useGradeMaster";
import {
  useAddProfile,
  useBranches,
  useEditProfile,
  useEmployeeGeoTown,
  useGetDesignationsData,
  useGetEmployeeStatusData,
  useGetEODstatus,
  useGetFullSyncStatus,
  usePositionData,
  useReportingToPositionData,
  useRoles,
} from "../hooks/useEmployee";
import { useGetLanguagesData } from "../../edetailing/hooks/useEdetailing";
import { BASE_URL } from "../../../Api/config";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { Input, Label, Spinner } from "reactstrap";
import { showToast } from "../../../utils/toastUtils";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { FaTrash } from "react-icons/fa";

const EditProfileModal = ({
  employeeProfileData,
  toggle,
  refresh,
  setRefresh,
  mode,
}: any) => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [orgUnit, setOrgUnit] = useState("");
  const [designation, setDesignation] = useState("");
  const [position, setPosition] = useState("");
  const [reportingTo, setReportingTo] = useState("");
  const [email, setEmail] = useState("");
  const [language, setLanguage] = useState<
    { id: number | string; [key: string]: any }[]
  >([]);
  const [eodCheck, setEodCheck] = useState("");
  const [canSync, setCanSync] = useState("");
  const [remark, setRemark] = useState("");
  const [HQTown, setHQTown] = useState("");
  const [media, setMedia] = useState<any>();
  const [grade, setGrade] = useState("");
  const [branch, setBranch] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [baseMonthlyTarget, setBaseMonthlyTarget] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [joinDate, setJoinDate] = useState("");
  const [isModalData, setIsModalData] = useState(false);

  // console.log("employeedata", employeeProfileData);
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  const { data: orgUnitList } = useGetOrgUnitsData({
    enable: true,
  });

  const { data: Designation } = useGetDesignationsData({
    enable: true,
  });

  const { data: PositionList } = usePositionData({
    params: {
      orgUnitId: employeeProfileData?.Orgunitid || orgUnit,
      employeeId: employeeProfileData?.EmployeeId,
    },
    enable: Boolean(employeeProfileData?.Orgunitid || orgUnit), // Trigger only when either is set
  });

  const { data: ReportingTo } = useReportingToPositionData({
    params: {
      positionId: position || employeeProfileData?.PositionId,
    },
    enable: Boolean(position || employeeProfileData?.PositionId),
  });

  const { data: EodStatus } = useGetEODstatus({
    enable: true,
  });

  const { data: CanFullSync } = useGetFullSyncStatus({
    enable: true,
  });

  const { data: languageData } = useGetLanguagesData({ enable: true });

  const { data: getGrade } = useGradeMastersData({ enable: true });

  const { data: getBranches } = useBranches({ enabled: true });

  const formattedGradeData = getGrade?.data.map((item: any) => ({
    id: item.Gradeid,
    label: item.GradeName,
  }));

  const formattedBranchesData = Object.entries(getBranches?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1],
    })
  );

  const formattedlangaugeData = languageData?.data.map((item: any) => ({
    id: item.id,
    label: item.label,
  }));

  console.log(
    "dataaa formatting++++++",
    formattedlangaugeData,
    "======",
    languageData
  );

  const { data: geoTown } = useEmployeeGeoTown({
    enabled: Boolean(position || employeeProfileData?.PositionId),
    params: {
      positionId: position || employeeProfileData?.PositionId,
    },
  });

  const { data: GetRoles } = useRoles({
    enabled: true,
    params: {
      start: 1,
      length: 30,
      search: "",
    },
  });

  const FormattedRoleData = Array.isArray(GetRoles?.data?.data)
    ? GetRoles.data.data.map((item: any) => ({
        id: item.RoleId.toString(),
        label: item.RoleName,
      }))
    : [];

  const FormattedHQTown = Object.entries(
    geoTown?.data?.EmployeeGeoTowns || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1], // Instead of label: val
  }));

useEffect(() => {
  if (
    mode === "edit" &&
    employeeProfileData &&
    formattedlangaugeData?.length > 0 &&
    !isModalData
  ) {
    setFirstname(employeeProfileData?.FirstName || "");
    setLastname(employeeProfileData?.LastName || "");
    setEmployeeCode(employeeProfileData?.EmployeeCode || "");
    setPhoneNumber(employeeProfileData?.Phone || "");
    setOrgUnit(employeeProfileData?.Orgunitid || "");
    setDesignation(employeeProfileData?.DesignationId || "");
    setPosition(employeeProfileData?.PositionId || "");
    setAddress(employeeProfileData?.ResiAddress || "");
    setEmail(employeeProfileData?.Email || "");
    setReportingTo(employeeProfileData?.ReportingToPositionId || "");
    setLanguage(
      employeeProfileData?.EmployeeSpokenLanguage?.split(",")
        .map((itm: string) =>
          formattedlangaugeData.find(
            (lang: any) => Number(lang.id) === Number(itm)
          )
        )
        .filter(Boolean) || []
    );
    setEodCheck(employeeProfileData?.Iseodcheckenabled ?? "");
    setCanSync(employeeProfileData?.CanFullSync ? "1" : "0");
    setHQTown(employeeProfileData?.Itownid || "");
    setGrade(employeeProfileData?.Gradeid || "");
    setBranch(employeeProfileData?.BranchId || "");
     if (employeeProfileData?.EmployeeMedia && employeeProfileData.EmployeeMedia !== 0) {
      setMedia(employeeProfileData.EmployeeMedia);
    } else {
      setMedia(null);
    }
    setBaseMonthlyTarget(employeeProfileData?.BaseMtarget||"")
    setRemark(employeeProfileData?.Remark||"")

    setIsModalData(true); // ✅ prevent re-filling and blocking input
  }
}, [employeeProfileData, formattedlangaugeData, mode]);


  const { mutate: UpdateProfile, isPending: isUpdate } = useEditProfile();
  const { mutate: AddEmployee, isPending: isSubmit } = useAddProfile();
  const DesignationsData = (Designation?.data || [])?.slice(1);
  // console.log("designation Data", DesignationsData);

  const FormattedDataorgunit = Object.entries(orgUnitList?.data || {}).map(
    (item: any) => ({
      id: item[0],
      label: item[1], // Instead of label: val
    })
  );

  const FormattedDataStatus = Object.entries(
    EodStatus?.data?.EODCheckStatus || {}
  ).map((item: any) => ({
    id: item[0],
    label: item[1], // Instead of label: val
  }));

  const FormattedDataCanSync = Object.entries(
    CanFullSync?.data?.FullSyncStatus || {}
  ).map(([key, value]) => ({
    id: String(key),
    label: String(value), // Instead of label: val
  }));

  const FormattedDataPosition = Object.entries(
    PositionList?.data?.Positions || {}
  ).map((item: any) => ({
    // item
    id: item[0],
    label: item[1], // Instead of label: val
  }));

  const FormattedDataReportingTo = Object.entries(
    ReportingTo?.data?.ReportingTo || {}
  ).map((item: any) => ({
    // item
    id: item[0],
    label: item[1], // Instead of label: val
  }));
  const handleMultiSelectChange = (selectedValues: (string | number)[]) => {
    const selectedData =
      selectedValues
        .map((id) =>
          formattedlangaugeData?.find(
            (unit: any) => Number(unit.id) === Number(id)
          )
        )
        .filter(Boolean) || [];

    setLanguage(selectedData); // ✅ set directly
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
        console.log("mediaiii", mediaId);

        setMedia(mediaId);
        console.log("Uploaded Media ID:", mediaId);
      } catch (error) {
        console.error("Media upload failed:", error);
      }
    }
  };


//   const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//   const file = e.target.files?.[0];
//   if (file) {
//     try {
//       const mediaResponse: any = await handleMedia(file);
//       console.log("mediaResponse:", mediaResponse);

//       // ✅ Normalize the media ID
//       const mediaId =
//         typeof mediaResponse === "object"
//           ? mediaResponse.id || mediaResponse.data?.id
//           : mediaResponse;

//       if (!mediaId) {
//         showToast.error("Media upload failed: No media ID returned");
//         return;
//       }

//       setMedia(String(mediaId)); // ✅ Store as string
//       console.log("Uploaded Media ID:", mediaId);
//     } catch (error) {
//       console.error("Media upload failed:", error);
//       showToast.error("Media upload failed");
//     }
//   }
// };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!firstname.trim()) {
      showToast.warning("First name is required");
      return;
    }
    if (!lastname.trim()) {
      showToast.warning("last name is required");
      return;
    }
    if (!orgUnit) {
      showToast.warning("Orgunit is required");
      return;
    }

    if (!employeeCode.trim()) {
      showToast.warning("Employee code is required");
      return;
    }
    if (!phoneNumber.trim()) {
      showToast.warning("Phone number is required");
      return;
    }
    if (!position) {
      showToast.warning("Position is required");
      return;
    }

    if (!reportingTo) {
      showToast.warning("Reporting to is required");
      return;
    }
    if (!HQTown) {
      showToast.warning("Town is required");
      return;
    }

    if (!grade) {
      showToast.warning("Grade is required");
      return;
    }

    if (!branch) {
      showToast.warning("Branch is required");
      return;
    }

    if (!designation) {
      showToast.warning("Designation is required");
      return;
    }

    if (!eodCheck) {
      showToast.warning("Eod Check is required");
      return;
    }

    if (!canSync) {
      showToast.warning("Can full sync is required");
      return;
    }

    

    console.log("Updated Employee Data:", {
      firstName: firstname,
      lastName: lastname,
      empCode: employeeCode,
      phone: phoneNumber,
      ressiAddress: address,
      orgUnitId: orgUnit,
      designationId: designation,
      positionId: position,
      employeeId: employeeProfileData?.EmployeeId,
      spokenLanguages: language.map((lang) => lang.id), // Include employee Id if needed by backend
      email: email,
      reportingToPositionId: reportingTo,
      townId: HQTown,
      remark: remark,
      gradeId: grade,
      branchId: branch,
      employeeMediaId: media,
      profilePicId: null,
      baseMonthlyTarget: baseMonthlyTarget,
      password: password,
      roleId: role,
      birthDate: birthDate,
      joinDate: joinDate,
    });

    const payload: any = {
      firstName: firstname,
      lastName: lastname,
      employeeCode: employeeCode,
      phone: phoneNumber,
      ressiAddress: address,
      orgUnitId: orgUnit,
      designationId: designation,
      positionId: position,
      employeeMediaId: media,
      spokenLanguages: language.map((lang) => lang.id), // Include employee Id if needed by backend
      email: email,
      gradeId: grade,
      branchId: branch,
      reportingToPositionId: reportingTo,
      townId: HQTown,
      remark: remark,
      eodCheckEnabled: eodCheck,
      canFullSync: canSync,
      profilePicId: "",
      birthDate: birthDate,
      joinDate: joinDate,
      baseMonthlyTarget: baseMonthlyTarget,
    };

    if (mode === "edit" && employeeProfileData?.EmployeeId) {
      payload.employeeId = employeeProfileData.EmployeeId;
      UpdateProfile(payload, {
        onSuccess: () => toggle(), // close after success
      });
    } else {
      if (!role) {
        showToast.warning("Role is required");
        return;
      }

      if (!password) {
        showToast.warning("Password is required");
        return;
      }

      Object.assign(payload, {
        roleId: role,
        password,
        baseMonthlyTarget,
      });
      AddEmployee(payload, {
        onSuccess: () => toggle(), // close after success
      });
    }
  };

const isLoading =
  (mode === "edit" && !employeeProfileData) || !formattedlangaugeData?.length;

  return (
    <>
      {isLoading?(<div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          
        </div>):(
  <form onSubmit={handleSubmit}>
        <div className="row mb-3">
        <div className="col-md-3">
      <RouteDropdown
              DropdownHeading="Org Unit*"
              value={orgUnit}
              onChange={(value: any) => {
                setOrgUnit(value);
              }}
              options={FormattedDataorgunit || []}
              />
        </div>

        <div className="col-md-3">
        <CustomInput
              type="text"
              label="First Name*"
              className="form-control"
              placeholder="Enter First name"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <CustomInput
              label="Last Name*"
              type="text"
              className="form-control"
              placeholder="Enter Last name"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}

          />
        </div>
        {/* <div className="col-md-3">
          <CustomInput
          label="Address"
            type="text"
            className="form-control"
            placeholder="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div> */}
        {/* {mode == "add" && (
          <>
            <div className="col-md-3">
         <CustomInput
  label="Birth Date"
  type="date"
  className="form-control"
  value={birthDate}
  onChange={(e) => {
    const selectedDate = e.target.value;
    if (joinDate && new Date(selectedDate) >= new Date(joinDate)) {
      showToast.warning("Birth Date must be Less than Join Date");
      return;
    }
    setBirthDate(selectedDate);
  }}
/>
            </div>
            <div className="col-md-3">
        <CustomInput
  label="Join Date"
  type="date"
  className="form-control"
  value={joinDate}
  onChange={(e) => {
    const selectedDate = e.target.value;
    if (birthDate && new Date(selectedDate) <= new Date(birthDate)) {
      showToast.warning("Join Date must be Greater than Birth Date");
      return;
    }
    setJoinDate(selectedDate);
  }}
/>
            </div>
          </>
        )}
        <div className="col-md-3">
          <RouteDropdown
            value={position}
            DropdownHeading="Position*"
            options={FormattedDataPosition || []}
            onChange={(value: any) => {
              setPosition(value);
            }}
          />
        </div>
        <div className="col-md-3">
          <RouteDropdown
            value={reportingTo}
            DropdownHeading="Reporting To*"
            options={FormattedDataReportingTo || []}
            onChange={(value: any) => {
              setReportingTo(value);
            }}
          />
        </div>
        <div className="col-md-3">
          <RouteDropdown
            DropdownHeading="Town*"
            value={HQTown}
            onChange={(value: any) => {
              setHQTown(value);
            }}
            options={FormattedHQTown || []}
          />
        </div> */}

          <div className="col-md-3">
            <CustomInput
              label="Employee Code*"
              type="text"
              className="form-control"
              placeholder="Enter Employee Code"
              value={employeeCode}
              onChange={(e) => setEmployeeCode(e.target.value)}
              // max={20}
              maxLength={20}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              type="email"
              label="Email"
              className="form-control"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              label="Phone Number*"
              type="number"
              maxLength={10}
              className="form-control"
              placeholder="Enter Phone Number"
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value.slice(0, 10); // limit to 10 digits
                setPhoneNumber(value);
              }}
            />
          </div>
          <div className="col-md-3">
            <CustomInput
              label="Address"
              type="text"
              className="form-control"
              placeholder="Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          {mode == "add" && (
            <>
              <div className="col-md-3">
                <CustomInput
                  label="Birth Date"
                  type="date"
                  className="form-control"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <CustomInput
                  type="date"
                  label="Join Date"
                  className="form-control"
                  min={
                    new Date(new Date().setDate(new Date().getDate() - 14))
                      .toISOString()
                      .split("T")[0]
                  }
                  value={joinDate}
                  onChange={(e) => setJoinDate(e.target.value)}
                />
              </div>
            </>
          )}
          <div className="col-md-3">
            <RouteDropdown
              value={position}
              DropdownHeading="Position*"
              options={FormattedDataPosition || []}
              onChange={(value: any) => {
                setPosition(value);
              }}
            />
          </div>
          <div className="col-md-3">
            <RouteDropdown
              value={reportingTo}
              DropdownHeading="Reporting To*"
              options={FormattedDataReportingTo || []}
              onChange={(value: any) => {
                setReportingTo(value);
              }}
            />
          </div>
          <div className="col-md-3">
            <RouteDropdown
              DropdownHeading="Town*"
              value={HQTown}
              onChange={(value: any) => {
                setHQTown(value);
              }}
              options={FormattedHQTown || []}
            />
          </div>

          <div className="col-md-3">
            <RouteDropdown
              DropdownHeading="Grade*"
              value={grade}
              onChange={(value: any) => {
                setGrade(value);
              }}
              options={formattedGradeData || []}
            />
          </div>
          <div className="col-md-3">
            <RouteDropdown
              DropdownHeading="Branch*"
              value={branch}
              onChange={(value: any) => {
                setBranch(value);
              }}
              options={formattedBranchesData || []}
            />
          </div>
          {mode == "add" && (
            <>
              <div className="col-md-3 ">
                <div className="form-input position-relative">
                  <CustomInput
                    type="password"
                    label="Password*"
                    placeholder="Enter Password"
                    onChange={(event) => setPassword(event.target.value)}
                    value={password}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <RouteDropdown
                  value={role}
                  DropdownHeading="Role*"
                  options={FormattedRoleData || []}
                  onChange={(value: any) => {
                    setRole(value);
                  }}
                />
              </div>
            </>
          )}
          <div className="col-md-3">
            <label style={{ fontWeight: "500", marginTop: "8px" }}>
              Remark
            </label>
            <textarea
              className="form-control"
              style={{ padding: "10px", lineHeight: "14px", height: "45px" }}
              placeholder="Remark"
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <CustomInput
              label="Base Monthly Target"
              type="text"
              className="form-control"
              placeholder="Enter Base Monthly Target"
              value={baseMonthlyTarget}
              onChange={(e) => setBaseMonthlyTarget(e.target.value)}
              maxLength={20}
            />
          </div>

          <div className="col-md-3">
            <RouteDropdown
              DropdownHeading="Designation*"
              options={DesignationsData || []}
              onChange={(value: any) => {
                setDesignation(value);
              }}
              value={designation}
            />
          </div>

          <div className="col-md-3">
            <RouteDropdown
              options={formattedlangaugeData || []}
              isMulti={true}
              value={language.map((unit) => unit.id.toString())}
              onChange={(value: any) => {
                handleMultiSelectChange(value);
              }}
              DropdownHeading="Spoken Languages"
            />
          </div>
          <div className="col-md-3">
            <RouteDropdown
              value={eodCheck}
              DropdownHeading="EOD Check*"
              options={FormattedDataStatus || []}
              onChange={(value: any) => {
                setEodCheck(value);
              }}
            />
          </div>
          <div className="col-md-3">
            <RouteDropdown
              value={canSync}
              DropdownHeading="Can Full sync*"
              options={FormattedDataCanSync || []}
              onChange={(value: any) => {
                setCanSync(value);
              }}
            />
          </div>

          <div className="col-md-3 mt-2">
            <label style={{ fontWeight: "500" }}>Media</label>
            <input
              type="file"
              className="form-control"
              accept="image/*"
              onChange={handleFileChange}
              style={{
                border: "2px solid #EDEDED",
                borderRadius: "8px",
                padding: "13px",
                fontSize: "14px",
                width: "100%",
              }}
            />
          </div>

        {media && media !== "0" && media !== 0 && (
  <div className="row mb-3">
    <div className="col-md-6" style={{ marginBottom: "10px" }}>
      <label style={{ fontWeight: "500", display: "block" }}>
        Uploaded Media
      </label>

      <div
        style={{
          position: "relative",
          display: "inline-block",
          marginTop: "8px",
        }}
      >
        <img
          src={`${BASE_URL}${media}`}
          alt="Uploaded Media"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "8px",
            marginTop: "8px",
            objectFit: "cover",
          }}
          onError={(e) => {
            e.currentTarget.style.display = "none"; // hide broken image
          }}
        />

        <FaTrash
          size={18}
          color="white"
          style={{
            position: "absolute",
            top: "4px",
            right: "1px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            padding: "4px",
            cursor: "pointer",
            transition: "transform 0.2s ease",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.transform = "scale(1.1)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => setMedia(null)}
          title="Remove Image"
        />
      </div>
    </div>
  </div>
)}

        </div>
        <div className="d-flex justify-content-start mt-3 gap-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
            disabled={isSubmit || isUpdate}
          >
            {mode === "edit"
              ? isUpdate
                ? "Updating..."
                : "Update"
              : isSubmit
              ? "Submitting..."
              : "Submit"}
          </Btn>
          <Btn
            style={{
              backgroundColor: "#F9FAFC",
              color: "#000",
              border: "1px solid #E0E0E0",
            }}
            type="button"
            onClick={() => {
              toggle();
              setRefresh(false);
            }}
          >
            Cancel
          </Btn>
        </div>
      </form>
        )
      }
    </>
  );
};

export default EditProfileModal;
